import React, { useState, useCallback } from 'react'
import { format } from 'date-fns'
import { useClasses } from 'lib/utilities/react'

import { useMessageThread } from "../../libs/store/common/threads"
import { useOwner } from "../../libs/store/common/owners"
import { useOwnerUser } from '../../libs/store/common/owner_users'

function MessageIcon({ message, isUnread }) {
  const classes = useClasses(['icon', isUnread ? 'unread' : null])
  const iconClasses = useClasses([
    'fa-solid',
    message.group_only ? 'fa-users' : 'fa-user'
  ])

  return <div className={classes}>
    <div>
      <i className={iconClasses}></i>
    </div>
  </div>
}

export function Message({message}) {
  const { message_thread } = useMessageThread(message.comment_thread_id)
  const { owner } = useOwner(message.owner_id)
  const [ hovering, setHovering ] = useState(false)
  const isUnread = message_thread && message.id > message_thread.last_seen_id

  const ownerUserId = [message.owner_id, message.posted_by].join(",")
  const { owner_user: user } = useOwnerUser(ownerUserId)

  const time = format(new Date(message.posted_at), "h:mm a")

  const handleOnHover = useCallback(() => setHovering(true), [setHovering])
  const handleOffHover = useCallback(() => setHovering(false), [setHovering])
  const handleClick = () => message_thread.link ? window.location = message_thread.link : null
  const classes = useClasses([
    'message',
    hovering && 'hovering'
  ])  

  if (!message_thread || !owner || !user)
    return null

  return <div className={classes} onMouseEnter={handleOnHover} onMouseLeave={handleOffHover} onClick={handleClick}>
    <MessageIcon message={message} thread={message_thread} isUnread={isUnread} />
    <div className="message-details">
      <div className="title">
        <span className="hovering-highlight">
          {user?.name} ({user?.label})
        </span> has sent you a message in {owner?.location}</div>
      <div className="time">{time}</div>
      <div className="message-area">
        { owner?.message_heading ? <div className="message-heading">{owner?.message_heading}</div> : null}
        <div className="message-text">{message.message}</div>
      </div>
    </div>
    <div className="action-arrow">
      <i className="fa-light fa-chevron-right"></i>
    </div>
  </div>
}